export const directionContent = [
  'Sede principal',
  'Edif. BTU, calle Cecilio Acosta, entre calles Páez y Sucre,',
  'Chacao, Caracas, Venezuela.',
  'info@grupov.com.ve',
  '0212 - 822.12.50 / 0212 - 313.55.50'
]
